export default __webpack_public_path__ + "img/5ad6e5972edccfd32bbdbb9c0d4674f6.png";